/**
 * How much of the plan's storage is gone (block 06).
 *
 * Separate from `useUploadImage` on purpose (ISP): the drop-zone wants to say
 * "3.1 of 5 GB used" *before* someone picks a 4GB file, and a surface that only
 * displays quota should not have to mount an upload mutation to read it.
 */
import { useQuery } from "@tanstack/react-query";
import { getNookClient } from "../client.js";
import { queryKeys } from "../query-keys.js";
export function useStorageUsage() {
    return useQuery({
        queryKey: queryKeys.storage.usage(),
        queryFn: () => getNookClient().getStorageUsage(),
    });
}
//# sourceMappingURL=use-storage-usage.js.map